import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import VnPagination from '@ui/components/VnPagination';
import { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { getAllSmallJobWorkOrderAsync, getAllWorkOrderWithoutTechnicianAsync, getWorkshopLocationAsync, getAllTechniciansWithWorkordersAsync } from '@application/features/plannings/planningThunk';
import Select from 'react-select';
import { locationDropDownStyles } from '@ui/styles/location-dropdown-style';
import WithoutTechnicianWorkOrdersTable from './WithoutTechnicianWorkOrdersTable';
import { useNavigate } from 'react-router-dom';
import ListOfTechnicianTable from './ListOfTechniciansTable';
import { getAllJobCategoriesAsync, getAllWorkOrderStatusAsync, getAllWorkshopLocationByCurrentEmployeeAsync, updateWorkorderToUrgentAsync } from '@application/features/workorders/workorderThunk';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { createEmployeeSettingsAsync, getEmployeeSettingsAsync } from '@application/features/auth/authThunks';
import { VisserModule } from '@application/common/enums/visser-module';
const Planning = () => {
    const [activeTab, setActiveTab] = useState('MechanicListTable');
    const [showWithoutTechnicianGridHeader] = useState(true);
    const [workShopLocationId, setWorkShopLocationId] = useState(0);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { workShopLocationDropdown, withoutTechnicianWorkOrders, withTechniciansWorkorderRequest } = useAppSelector((state) => state.planning);
    const { currentUser, currentEmployeeSettings } = useAppSelector((state) => state.auth);
    const { workShopLocationByCurrentEmployeeDropdown } = useAppSelector((state) => state.workorder);
    const [searchTechnicianWorkOrderText, setSearchTechnicianWorkOrderText] = useState('');
    VnDocumentTitle('Visser WP Planning');
    const defaultSortingCriteria = {
        sortColumnKey: 'workOrderNumber',
        sortDirection: 'desc'
    };
    const defaultSmallJobWorkorderFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        urgent: null,
        desiredDeliveryDate: null,
        workOrderNumber: null,
        debtorName: null,
        workOrderStatus: null,
        workOrderCategory: null,
        description: null,
        projectManagerIdentifier: null,
        workShopLocationId: workShopLocationId
    };
    const defaultWithoutTechniciansFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        urgent: null,
        desiredDeliveryDate: null,
        workOrderNumber: null,
        debtorName: null,
        workOrderStatus: null,
        workOrderCategory: null,
        description: null,
        projectManagerIdentifier: null,
        workShopLocationId: workShopLocationId
    };
    const [smallJobWorkorderFilterValues, setsmallJobWorkorderFilterValues] = useState(defaultSmallJobWorkorderFilterValues);
    const [withoutTechniciansFilterValues, setwithoutTechniciansFilterValues] = useState(defaultWithoutTechniciansFilterValues);
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    };
    // function searchWorkOrderWithoutTechnicianHandler(searchText: string): void {
    //     setSearchWithoutTechnicianWorkOrderText(searchText);
    //     dispatch(
    //         getAllWorkOrderWithoutTechnicianAsync({
    //             ...withoutTechnicianWorkOrderRequest,
    //             workShopLocationId: workShopLocationId,
    //             filter: searchText
    //         })
    //     );
    // }
    // function onWorkOrderPageChange(pageNumber: number): void {
    // if (activeTab === 'SmallJobTable') {
    //     dispatch(getAllSmallJobWorkOrderAsync({ ...smallJobWorkOrderRequest,workShopLocationId:workShopLocationId, pageNumber: pageNumber, filter: searchSmallJobWorkOrderText }));
    // } else
    //     if (activeTab === 'WithoutMechanicListTable') {
    //         dispatch(
    //             getAllWorkOrderWithoutTechnicianAsync({
    //                 ...withoutTechnicianWorkOrderRequest,
    //                 workShopLocationId: workShopLocationId,
    //                 pageNumber: pageNumber,
    //                 filter: searchWithoutTechnicianWorkOrderText
    //             })
    //         );
    //     }
    // }
    // useEffect(() => {
    //     if (activeTab === 'SmallJobTable') {
    //         dispatch(getAllSmallJobWorkOrderAsync(smallJobWorkorderFilterValues));
    //     }
    //     else if (activeTab === 'WithoutMechanicListTable') {
    //         dispatch(getAllWorkOrderWithoutTechnicianAsync({ ...withoutTechnicianWorkOrderRequest,workShopLocationId:workShopLocationId,  filter: searchWithoutTechnicianWorkOrderText }));
    //     }
    //     else if (activeTab == 'MechanicListTable') {
    //         console.log(workShopLocationId,"ws");
    //         dispatch(getAllTechniciansWithWorkordersAsync({...withTechniciansWorkorderRequest,workShopLocationId:workShopLocationId,filter: searchTechnicianWorkOrderText}));
    //     }
    // }, [activeTab, smallJobWorkOrderRequest,withoutTechnicianWorkOrderRequest,workShopLocationId, dispatch]);
    useEffect(() => {
        dispatch(getAllWorkOrderStatusAsync());
        if (activeTab === 'SmallJobTable') {
            setsmallJobWorkorderFilterValues(defaultSmallJobWorkorderFilterValues);
            dispatch(getAllSmallJobWorkOrderAsync(defaultSmallJobWorkorderFilterValues));
        }
        else if (activeTab === 'WithoutMechanicListTable') {
            setwithoutTechniciansFilterValues(defaultWithoutTechniciansFilterValues);
            dispatch(getAllWorkOrderWithoutTechnicianAsync(defaultWithoutTechniciansFilterValues));
        }
        else if (activeTab == 'MechanicListTable') {
            dispatch(getAllTechniciansWithWorkordersAsync({
                ...withTechniciansWorkorderRequest,
                workShopLocationId: workShopLocationId,
                filter: searchTechnicianWorkOrderText
            }));
        }
    }, [activeTab, workShopLocationId]);
    const handleLocationDropdownChange = (selectedOption) => {
        if (selectedOption) {
            setWorkShopLocationId(selectedOption.value);
            dispatch(createEmployeeSettingsAsync({
                employeeId: currentUser?.id ? parseInt(currentUser.id) : 0,
                workshopLocationId: selectedOption.value,
                moduleId: VisserModule.WP_Planning
            }))
                .unwrap()
                .then((res) => { })
                .catch((error) => { });
        }
    };
    useEffect(() => {
        dispatch(getAllWorkshopLocationByCurrentEmployeeAsync());
        dispatch(getWorkshopLocationAsync());
        dispatch(getAllJobCategoriesAsync());
        dispatch(getEmployeeSettingsAsync(currentUser?.id ? parseInt(currentUser.id) : 0));
    }, []);
    useEffect(() => {
        if (workShopLocationByCurrentEmployeeDropdown && workShopLocationByCurrentEmployeeDropdown.length > 0) {
            const defaultLocation = workShopLocationByCurrentEmployeeDropdown[0].value;
            if (currentEmployeeSettings) {
                const employeeSavedLocation = currentEmployeeSettings.find((x) => x.moduleId === VisserModule.WP_Planning);
                if (employeeSavedLocation) {
                    const locationExists = workShopLocationByCurrentEmployeeDropdown.some((item) => item.value === employeeSavedLocation.workshopLocationId);
                    if (locationExists) {
                        setWorkShopLocationId(employeeSavedLocation.workshopLocationId);
                    }
                    else {
                        setWorkShopLocationId(defaultLocation);
                    }
                }
                else {
                    setWorkShopLocationId(defaultLocation);
                }
            }
            else {
                setWorkShopLocationId(defaultLocation);
            }
        }
    }, [currentEmployeeSettings, workShopLocationByCurrentEmployeeDropdown]);
    const onRowClick = (rowId) => {
        window.open(`/admin/WorkordersTabs/${rowId}`, '_blank');
    };
    function searchWorkOrderWithTechnicianHandler(searchText) {
        setSearchTechnicianWorkOrderText(searchText);
        dispatch(getAllTechniciansWithWorkordersAsync({
            ...withTechniciansWorkorderRequest,
            workShopLocationId: workShopLocationId,
            filter: searchText,
            pageNumber: 1
        }));
    }
    /*Small Job Workorder sorting and filtering */
    // const updateSmallJobFilterValues = (newValues: Partial<SmallJobWorkorderFilterDto>) => {
    //     setsmallJobWorkorderFilterValues((prevValues) => ({
    //         ...prevValues,
    //         ...newValues
    //     }));
    // };
    // function searchSmallJobWorkOrderHandler(searchText: string): void {
    //     updateSmallJobFilterValues({ filter: searchText });
    //     dispatch(
    //         getAllSmallJobWorkOrderAsync({
    //             ...smallJobWorkorderFilterValues,
    //             filter: searchText,
    //             workShopLocationId: workShopLocationId
    //         })
    //     );
    //     // setSearchSmallJobWorkOrderText(searchText);
    //     // dispatch(getAllSmallJobWorkOrderAsync({ ...smallJobWorkOrderRequest,workShopLocationId:workShopLocationId,  filter: searchText }));
    // }
    // function onSmallJobWorkOrderPageChange(pageNumber: number): void {
    //     updateSmallJobFilterValues({ pageNumber });
    //     dispatch(
    //         getAllSmallJobWorkOrderAsync({
    //             ...smallJobWorkorderFilterValues,
    //             pageNumber,
    //             workShopLocationId: workShopLocationId
    //         })
    //     );
    // }
    // function smallJobWorkOrderSortingHandler(data: SortingDto) {
    //     updateSmallJobFilterValues({
    //         sortColumnKey: data.sortColumnKey!,
    //         sortDirection: data.sortDirection
    //     });
    //     dispatch(
    //         getAllSmallJobWorkOrderAsync({
    //             ...smallJobWorkorderFilterValues,
    //             sortColumnKey: data.sortColumnKey!,
    //             sortDirection: data.sortDirection,
    //             workShopLocationId: workShopLocationId
    //         })
    //     );
    // }
    // function smallJobWorkOrderFilteringHandler(data: Partial<SmallJobWorkorderFilterDto>) {
    //     data.pageNumber = 1;
    //     updateSmallJobFilterValues(data);
    //     dispatch(
    //         getAllSmallJobWorkOrderAsync({
    //             ...smallJobWorkorderFilterValues,
    //             ...data,
    //             workShopLocationId: workShopLocationId
    //         })
    //     );
    // }
    /*Without Technicians sorting and filtering */
    const updateWithoutTechniciansFilterValues = (newValues) => {
        setwithoutTechniciansFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchWorkOrderWithoutTechnicianHandler(searchText) {
        updateWithoutTechniciansFilterValues({ filter: searchText });
        dispatch(getAllWorkOrderWithoutTechnicianAsync({
            ...withoutTechniciansFilterValues,
            filter: searchText,
            workShopLocationId: workShopLocationId,
            pageNumber: 1
        }));
    }
    function onWithoutTechniciansWorkOrderPageChange(pageNumber) {
        updateWithoutTechniciansFilterValues({ pageNumber });
        dispatch(getAllWorkOrderWithoutTechnicianAsync({
            ...withoutTechniciansFilterValues,
            pageNumber,
            workShopLocationId: workShopLocationId
        }));
        // if (activeTab === 'SmallJobTable') {
        //     dispatch(getAllSmallJobWorkOrderAsync({ ...smallJobWorkOrderRequest,workShopLocationId:workShopLocationId, pageNumber: pageNumber, filter: searchSmallJobWorkOrderText }));
        // } else
        // if (activeTab === 'WithoutMechanicListTable') {
        //     dispatch(
        //         getAllWorkOrderWithoutTechnicianAsync({
        //             ...withoutTechnicianWorkOrderRequest,
        //             workShopLocationId: workShopLocationId,
        //             pageNumber: pageNumber,
        //             filter: searchWithoutTechnicianWorkOrderText
        //         })
        //     );
        // }
    }
    function withoutTechniciansWorkOrderSortingHandler(data) {
        updateWithoutTechniciansFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllWorkOrderWithoutTechnicianAsync({
            ...withoutTechniciansFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection,
            workShopLocationId: workShopLocationId
        }));
    }
    function withoutTechniciansWorkOrderFilteringHandler(data) {
        data.pageNumber = 1;
        updateWithoutTechniciansFilterValues(data);
        dispatch(getAllWorkOrderWithoutTechnicianAsync({
            ...withoutTechniciansFilterValues,
            ...data,
            workShopLocationId: workShopLocationId
        }));
    }
    const handleWithoutTechnicianUrgentToggleButtonClick = (workOrderId, urgent) => {
        const urgentDto = {
            id: workOrderId,
            Urgent: urgent
        };
        dispatch(updateWorkorderToUrgentAsync(urgentDto))
            .unwrap()
            .then((res) => {
            dispatch(getAllWorkOrderWithoutTechnicianAsync({
                ...withoutTechniciansFilterValues,
                workShopLocationId: workShopLocationId
            }));
        });
    };
    const handleTechnicianUrgentToggleButtonClick = (workOrderId, urgent) => {
        const urgentDto = {
            id: workOrderId,
            Urgent: urgent
        };
        dispatch(updateWorkorderToUrgentAsync(urgentDto))
            .unwrap()
            .then((res) => {
            dispatch(getAllTechniciansWithWorkordersAsync({
                ...withTechniciansWorkorderRequest,
                workShopLocationId: workShopLocationId
            }));
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: '0rem',
                    marginTop: '2rem',
                    marginBottom: '1rem'
                }, children: [_jsx("h4", { children: "WP Planning" }), _jsxs("div", { className: 'vn-Status-Container', children: [_jsx("label", { className: 'vn-status-label mt-1', children: "Werkplaats-Locatie:" }), _jsx(Select, { placeholder: 'Select werkorder', isSearchable: false, styles: locationDropDownStyles, value: workShopLocationByCurrentEmployeeDropdown?.some((x) => x.value == workShopLocationId)
                                    ? workShopLocationByCurrentEmployeeDropdown?.filter((x) => x.value === workShopLocationDropdown?.find((option) => option.value == workShopLocationId)?.value)
                                    : workShopLocationDropdown?.find((option) => option.value == workShopLocationId) || null, options: workShopLocationByCurrentEmployeeDropdown, onChange: handleLocationDropdownChange })] })] }), _jsxs(Tabs, { activeKey: activeTab, onSelect: handleTabChange, className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'MechanicListTable', title: 'Lijst met monteur' }), _jsx(Tab, { eventKey: 'WithoutMechanicListTable', title: 'Geen monteur toegewezen' })] }), _jsxs("div", { className: 'mt-0', children: [activeTab === 'WithoutMechanicListTable' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: showWithoutTechnicianGridHeader, onSearch: searchWorkOrderWithoutTechnicianHandler }), _jsx(WithoutTechnicianWorkOrdersTable, { workOrders: withoutTechnicianWorkOrders?.items, onRowClick: onRowClick, onSorting: withoutTechniciansWorkOrderSortingHandler, onFilter: withoutTechniciansWorkOrderFilteringHandler, defaultSortingCriteria: defaultSortingCriteria, onUrgentToggleUpdate: handleWithoutTechnicianUrgentToggleButtonClick }), _jsx("div", { className: 'mt-3', children: withoutTechnicianWorkOrders && (_jsx(VnPagination, { currentPage: withoutTechnicianWorkOrders?.pageNumber, totalPages: withoutTechnicianWorkOrders?.totalPages, onPageChange: onWithoutTechniciansWorkOrderPageChange })) })] })), activeTab == 'MechanicListTable' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchWorkOrderWithTechnicianHandler }), _jsx(ListOfTechnicianTable, { onRowClick: onRowClick, onUrgentToggleUpdate: handleTechnicianUrgentToggleButtonClick })] }))] })] }));
};
export default Planning;
